import { useEffect } from 'react';
import useUtmData from './useUtmData';

const useUtmToStorage = () => {
    const dsHook = useUtmData('ds');

    useEffect(() => {
        const dsData = dsHook.decodeFromUrl();
        if (dsData) {
            localStorage.setItem('MemoryOSDownSale', JSON.stringify(dsData));
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

export default useUtmToStorage;